import { render, staticRenderFns } from "./MessageToaster.vue?vue&type=template&id=25f8536b"
import script from "./MessageToaster.vue?vue&type=script&lang=ts"
export * from "./MessageToaster.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports